import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import PublicLayout from "../components/layout/PublicLayout";
import { SITE_NAME } from "../utils/seo";

const NotFound = ({
  code = "404",
  title = "Page not found",
  message,
  isDownloading,
  handleDownload,
}) => (
  <PublicLayout
    isDownloading={isDownloading}
    handleDownload={handleDownload}
  >
    <Helmet>
      <title>{`${title} | ${SITE_NAME}`}</title>
      <meta
        name="description"
        content={
          message ||
          "This page could not be found in Aurio Rajaa's portfolio."
        }
      />
      <meta name="robots" content="noindex, follow" />
    </Helmet>

    <section className="not-found-page">
      <div className="container">
        <div className="not-found-grid">
          <div>
            <p className="not-found-code">{code}</p>
            <h1 className="not-found-title">{title}</h1>
            <p className="not-found-message">
              {message ||
                "You took a turn off the map. This page does not exist, but the way home is right here."}
            </p>
            <Link className="btn btn-large" to="/">
              <ArrowLeft size={17} />
              Back to home
            </Link>
          </div>

          <div className="not-found-card" aria-hidden="true">
            <span>{code}</span>
          </div>
        </div>
      </div>
    </section>
  </PublicLayout>
);

export default NotFound;
